import { disableNextButton, enableNextButton } from './utils';
import { ImperialInputHandler } from './utils/imperial-input';
import { isImperialInputEmpty } from './utils/imperial-validator';

if (typeof window.com === 'undefined') window.com = new Object();
if (typeof window.com.parkside === 'undefined') window.com.parkside = new Object();
if (typeof window.com.parkside.deckform === 'undefined') window.com.parkside.deckform = new Object();
if (typeof com.parkside.tp_lform_renderer === 'undefined') window.com.parkside.tp_lform_renderer = new Object();

// constructor
window.com.parkside.deckform = function () {};

window.com.parkside.deckform.init_form_selection = function () {
  if (jQuery('input[name=form_deckform]:checked').length) {
    if (!jQuery('input[name=form_deckform]:checked').hasClass('selected')) {
      var row = jQuery('input[name=form_deckform]:checked').parents('tr');
      jQuery('.liste .selected').removeClass('selected');
      row.addClass('selected');
    }
  }

  jQuery('table.liste tbody tr:not(.filler)')
    .css({ cursor: 'pointer' })
    .click(function () {
      var $input = jQuery(this).find('input[name=form_deckform]');
      $input.change();
    });

  var changing = false;
  jQuery('input[name=form_deckform]').change(function () {
    if (changing) return;
    changing = true;
    this.checked = true;

    var $tr = jQuery(this).parents('tr');
    if (!$tr.hasClass('selected')) {
      jQuery('.liste .selected').removeClass('selected');
      $tr.addClass('selected');
    }

    changing = false;
    jQuery('.btn-next').removeClass('btn-disabled');
  });

  if (!jQuery('input[name=form_deckform]:checked').length) {
    jQuery('input[name=form_deckform]').first().change();
  }
};

// constructor
com.parkside.tp_qform_renderer = function (canvas_id, direction, $wrapper) {
  var t = this;
  jQuery(document).ready(function (e) {
    t.ready(canvas_id, direction, $wrapper);
  });
};

com.parkside.tp_qform_renderer.prototype = {
  /*
		Hier werden die Positionen aller Elemente angegeben in Abhängigkeit von der Richtung und dem Winkel.
			
		xl,yl : Position der längeren Richtungslinien
				
		letters: die Info-Buchstaben (x: CSS left, y: CSS top)
		
		Arraybelegung:
		[ 0, pi/2, pi, 3pi/2 ]
		
	*/

  configuration: {
    L: {
      start: [[5], [5]],
      xl: [10],
      yl: [25],
    },
    Q: {
      start: [[5], [5]],
      xl: [35],
      yl: [0],
    },
    letters: [
      {
        letter: 'A',
        x: [110],
        y: [5],
      },
      {
        letter: 'B',
        x: [235],
        y: [130],
      },
    ],
    l_direction: [170],
  },

  canvas_holder: null,
  canvas_wrapper: null,
  canvas: null,
  lform: null,
  angle: 0,
  initial_direction: null,
  current_direction: null,
  direction_lines: null,
  animating: false,
  length_letters: [],
  /*
		Erstellt die Form, die Richtungslinien und die Info-Buchstaben
		canvas_id - string - ID des HTML-Elements, das die Vektorgrafik beinhalten soll
		direction - string - Richtung ("Q" - Quer, "L" - Läng)
	*/

  ready: function (canvas_id, direction, wrapper) {
    var t = this;
    t.canvas_id = canvas_id;
    t.canvas_wrapper = wrapper;
    t.canvas_holder = jQuery(t.canvas_id);
    t.canvas = Raphael(canvas_id, t.canvas_holder.width(), t.canvas_holder.height());

    t.lform = t.canvas
      .path('M0,25v230h230v-230h-230')
      .attr({
        stroke: '#a7a7a7',
        fill: '270-#9c9b99-#82817f',
        'stroke-width': 1,
      })
      .animate({ transform: 'r' + t.angle });

    t.initial_direction = direction;
    t.current_direction = direction;
    t.direction_lines = t.drawDirectionLines(t.canvas, t.angle, direction);
    t.createLetters();
  },
  /*
		Zeichnet die Richtungslinien neu.
		direction - string - Richtung ("Q" - Quer, "L" - Läng)
	*/
  redrawLines: function (direction) {
    var t = this;

    if (t.animating) return;

    t.current_direction = direction;
    t.removeDirectionLines(t.direction_lines);
    t.direction_lines = t.drawDirectionLines(t.canvas, t.angle, direction);
  },
  /*
		Rotiert die Form, Richtungslinien und die Buchstaben
	*/
  rotateForm: function (angle) {
    var t = this;

    if (t.animating) return;

    if (typeof angle === 'undefined') {
      angle = 90;
    }

    t.animating = true;
    t.angle += angle;
    t.fadeoutDirectionLines(t.direction_lines);
    t.fadeoutLetters(t.length_letters);
    t.positionRadioButtons(t.angle);
    t.lform.animate({ transform: 'r' + t.angle }, 500, 'linear', function () {
      t.angle = t.angle % 360;
      t.lform.transform('r' + t.angle);
      t.positionLetters(t.angle);
      t.direction_lines = t.drawDirectionLines(t.canvas, t.angle, t.current_direction);
      t.animating = false;
    });
  },
  /*
		Ändert die Vertikale-Position der Richtung-Buttons
	*/
  positionRadioButtons: function (angle) {
    var t = this;
    if (angle > 0) {
      angle -= 360;
    }
    var windex = Math.abs((angle % 360) / 90);
    //jQuery("#l_direction").animate({top:this.configuration.l_direction[windex]+"px"});
    if (parseInt(jQuery('#l_direction').css('top')) !== t.configuration.l_direction[windex]) {
      jQuery('#l_direction').fadeOut('slow', function () {
        jQuery('#l_direction')
          .css({ top: t.configuration.l_direction[windex] + 'px' })
          .fadeIn('fast');
      });
    }
  },
  /*
		Erstellt die <span> Elemente für die Info-Buchstaben
	*/
  createLetters: function () {
    var config = this.configuration.letters;
    for (var letter in config) {
      var conf = config[letter];
      this.length_letters[letter] = jQuery('<span>' + conf.letter + '</span>')
        .css({
          left: conf.x[0],
          top: conf.y[0],
          position: 'absolute',
          display: 'block',
          'font-size': 12,
        })
        .appendTo(this.canvas_wrapper);
    }
  },
  /*
		Platziert die Info-Buchstaben in Abhängigkeit vom Winkel
	*/
  positionLetters: function (angle) {
    if (angle > 0) {
      angle -= 360;
    }
    var windex = Math.abs((angle % 360) / 90);
    var config = this.configuration.letters;
    for (var letter in config) {
      var $letter = this.length_letters[letter];
      conf = config[letter];
      $letter.css({ left: conf.x[windex], top: conf.y[windex] });
      $letter.fadeIn('fast');
    }
    return;
  },
  /*
		Blendet die Buchstaben aus
	*/
  fadeoutLetters: function (length_letters) {
    var config = this.configuration.letters;
    for (var letter in config) {
      var $letter = this.length_letters[letter];
      $letter.hide();
    }
  },
  /*
		Entfernt die Richtungslinien
	*/
  removeDirectionLines: function (direction_lines) {
    direction_lines && direction_lines.remove();
  },
  /*
		Blendet die Richtungslinien aus
	*/
  fadeoutDirectionLines: function (direction_lines) {
    direction_lines &&
      direction_lines.animate({ opacity: 0 }, 200, '<>', function () {
        direction_lines.remove();
      });
  },
  /*
		Zeichnet die Richtungslinien neu
	*/
  drawDirectionLines: function (canvas, angle, richtung) {
    if (!this.configuration[richtung]) return;
    if (angle > 0) {
      angle -= 360;
    }
    var config = this.configuration[richtung];
    var direction_lines = canvas.set();
    var windex = Math.abs((angle % 360) / 90);
    var x_start = config['xl'][windex];
    var y_start = config['yl'][windex];
    for (var i = config['start'][0][windex]; i < 210; i += 22) {
      var x = richtung === 'L' ? x_start + i : y_start;
      var y = richtung === 'L' ? y_start : x_start + i;
      var m = richtung === 'L' ? 'v' : 'h';
      direction_lines.push(canvas.path('M' + x + ',' + y + m + '230').attr({ stroke: '#d3d3d1' }));
    }
    return direction_lines;
  },
};

// constructor
com.parkside.tp_lform_renderer = function (canvas_id, direction, angle, $wrapper) {
  var t = this;
  jQuery(document).ready(function (e) {
    t.ready(canvas_id, direction, angle, $wrapper);
  });
};

/// class

com.parkside.tp_lform_renderer.prototype = {
  /*
		Hier werden die Positionen aller Elemente angegeben in Abhängigkeit von der Richtung und dem Winkel.
			
		xl,yl : Position der längeren Richtungslinien
		xs,ys : Position der kürzeren Richtungslinien
		start : verschiebung der Richtungslinien
		
		letters: die Info-Buchstaben (x: CSS left, y: CSS top)
		
		l_direction : Position des Richtungsauswahlboxes
		
		Arraybelegung:
		[ 0, pi/2, pi, 3pi/2 ]
		
	*/

  configuration: {
    L: {
      start: [
        [19, 19, 19, 19],
        [4, 10, 10, 4],
      ],
      xl: [25, 130, 130, 25],
      yl: [25, 25, 25, 25],
      xs: [150, 25, 25, 150],
      ys: [140, 140, 25, 25],
    },
    Q: {
      start: [
        [17, 17, 19, 19],
        [10, 10, 4, 4],
      ],
      xl: [130, 130, 25, 25],
      yl: [25, 25, 25, 25],
      xs: [25, 25, 150, 150],
      ys: [25, 140, 140, 25],
    },
    letters: [
      {
        letter: 'A',
        x: [75, 5, 190, 265],
        y: [5, 190, 265, 75],
      },
      {
        letter: 'B',
        x: [150, 75, 125, 190],
        y: [75, 120, 190, 150],
      },
      {
        letter: 'C',
        x: [190, 120, 75, 155],
        y: [120, 75, 150, 190],
      },
      {
        letter: 'D',
        x: [265, 190, 5, 75],
        y: [190, 5, 75, 265],
      },
    ],
    l_direction: [170, 170, 50, 50],
  },

  canvas_holder: null,
  canvas_wrapper: null,
  canvas: null,
  lform: null,
  angle: 0,
  initial_direction: null,
  current_direction: null,
  direction_lines: null,
  animating: false,
  length_letters: [],
  /*
		Erstellt die Form, die Richtungslinien und die Info-Buchstaben
		canvas_id - string - ID des HTML-Elements, das die Vektorgrafik beinhalten soll
		direction - string - Richtung ("Q" - Quer, "L" - Läng)
	*/

  ready: function (canvas_id, direction, angle, wrapper) {
    var t = this;
    t.canvas_id = canvas_id;
    t.canvas_wrapper = wrapper;
    t.canvas_holder = jQuery(t.canvas_id);
    t.canvas = Raphael(canvas_id, t.canvas_holder.width(), t.canvas_holder.height());

    t.lform = t.canvas
      .path('M25,25v230h230v-115h-115v-115h-115')
      .attr({
        stroke: '#a7a7a7',
        fill: '270-#9c9b99-#82817f',
        'stroke-width': 1,
      })
      .animate({ transform: 'r' + t.angle });

    t.angle = angle;

    t.createLetters();
    t.angle = t.angle % 360;
    t.lform.animate({ transform: 'r' + t.angle });
    t.positionLetters(t.angle);
    t.initial_direction = direction;
    t.current_direction = direction;
    t.direction_lines = t.drawDirectionLines(t.canvas, t.angle, direction);
    t.positionRadioButtons(t.angle);
  },
  /*
		Zeichnet die Richtungslinien neu.
		direction - string - Richtung ("Q" - Quer, "L" - Läng)
	*/
  redrawLines: function (direction) {
    var t = this;

    if (t.animating) return;

    t.current_direction = direction;
    t.removeDirectionLines(t.direction_lines);
    t.direction_lines = t.drawDirectionLines(t.canvas, t.angle, direction);
  },
  /*
		Rotiert die Form, Richtungslinien und die Buchstaben
	*/
  rotateForm: function (angle) {
    var t = this;

    if (t.animating) return;

    if (typeof angle === 'undefined') {
      angle = 90;
    }

    t.animating = true;
    t.angle += angle;
    t.fadeoutDirectionLines(t.direction_lines);
    t.fadeoutLetters(t.length_letters);
    t.positionRadioButtons(t.angle);
    t.lform.animate({ transform: 'r' + t.angle }, 500, 'linear', function () {
      t.angle = t.angle % 360;
      t.lform.transform('r' + t.angle);
      t.positionLetters(t.angle);
      t.direction_lines = t.drawDirectionLines(t.canvas, t.angle, t.current_direction);
      t.animating = false;
    });
  },
  /*
		Ändert die Vertikale-Position der Richtung-Buttons
	*/
  positionRadioButtons: function (angle) {
    var t = this;
    if (angle > 0) {
      angle -= 360;
    }
    var windex = Math.abs((angle % 360) / 90);
    //jQuery("#l_direction").animate({top:this.configuration.l_direction[windex]+"px"});
  },
  /*
		Erstellt die <span> Elemente für die Info-Buchstaben
	*/
  createLetters: function () {
    var config = this.configuration.letters;
    for (var letter in config) {
      var conf = config[letter];
      this.length_letters[letter] = jQuery('<span>' + conf.letter + '</span>')
        .css({
          left: conf.x[0],
          top: conf.y[0],
          position: 'absolute',
          display: 'block',
          'font-family': 'Tahoma, Geneva, Verdana, sans-serif',
          'font-size': 12,
        })
        .appendTo(this.canvas_wrapper);
    }
  },
  /*
		Platziert die Info-Buchstaben in Abhängigkeit vom Winkel
	*/
  positionLetters: function (angle) {
    if (angle > 0) {
      angle -= 360;
    }
    var windex = Math.abs((angle % 360) / 90);
    var config = this.configuration.letters;
    for (var letter in config) {
      var $letter = this.length_letters[letter];
      var conf = config[letter];
      $letter.css({ left: conf.x[windex], top: conf.y[windex] });
      $letter.fadeIn('fast');
    }
    return;
  },
  /*
		Blendet die Buchstaben aus
	*/
  fadeoutLetters: function (length_letters) {
    var config = this.configuration.letters;
    for (var letter in config) {
      var $letter = this.length_letters[letter];
      $letter.hide();
    }
  },
  /*
		Entfernt die Richtungslinien
	*/
  removeDirectionLines: function (direction_lines) {
    direction_lines && direction_lines.remove();
  },
  /*
		Blendet die Richtungslinien aus
	*/
  fadeoutDirectionLines: function (direction_lines) {
    direction_lines &&
      direction_lines.animate({ opacity: 0 }, 200, '<>', function () {
        direction_lines.remove();
      });
  },
  /*
		Zeichnet die Richtungslinien neu
	*/
  drawDirectionLines: function (canvas, angle, richtung) {
    if (!this.configuration[richtung]) return;
    if (angle > 0) {
      angle -= 360;
    }
    var config = this.configuration[richtung];
    var direction_lines = canvas.set();
    var windex = Math.abs((angle % 360) / 90);
    var x_start = config['xl'][windex];
    var y_start = config['yl'][windex];
    for (var i = config['start'][0][windex]; i < 110; i += 22) {
      var x = richtung === 'L' ? x_start + i : y_start;
      var y = richtung === 'L' ? y_start : x_start + i;
      var m = richtung === 'L' ? 'v' : 'h';
      direction_lines.push(canvas.path('M' + x + ',' + y + m + '230').attr({ stroke: '#d3d3d1' }));
    }
    x_start = config['xs'][windex];
    y_start = config['ys'][windex];
    for (var i = config['start'][1][windex]; i < 110; i += 22) {
      var x = richtung === 'L' ? x_start + i : y_start;
      var y = richtung === 'L' ? y_start : x_start + i;
      var m = richtung === 'L' ? 'v' : 'h';
      direction_lines.push(canvas.path('M' + x + ',' + y + m + '115').attr({ stroke: '#d3d3d1' }));
    }
    return direction_lines;
  },
};

com.parkside.deckform.init_untergrund = function () {
  function updateAnchoredSelection(value) {
    if (window.grounds) {
      var ground = window.grounds.find(function (element) {
        return element.value === value;
      });
      if (ground) {
        var checkbox = jQuery('#anchored_installation');
        if (checkbox.length) {
          if (ground.anchoredSelectionEnabled) {
            checkbox.attr('disabled', false);
          } else {
            checkbox.attr('disabled', true);
            checkbox.prop('checked', ground.anchoredDefaultValue ? 'checked' : '');
          }
        }
      }
    }
  }

  function updateProfiSelection(value) {
    var target = jQuery('.profi-mode-tools');
    if (value) {
      target.show();
    } else {
      target.hide();
    }
  }

  if (jQuery('input[name=untergrund]:checked').length) {
    var groundInput = jQuery('input[name=untergrund]:checked')[0];
    updateAnchoredSelection(groundInput.value);
    if (!jQuery('input[name=untergrund]:checked').hasClass('selected')) {
      var row = jQuery('input[name=untergrund]:checked').parents('tr');
      jQuery('.liste .selected').removeClass('selected');
      row.addClass('selected');
      jQuery('.btn-next').removeClass('btn-disabled');
    }
  }

  jQuery('table.liste tbody tr:not(.filler)')
    .css({ cursor: 'pointer' })
    .click(function () {
      var $input = jQuery(this).find('input[name=untergrund]');
      $input.change();
    });

  var changing = false;
  jQuery('input[name=untergrund]').change(function () {
    if (changing) return;
    changing = true;
    this.checked = true;

    changing = false;
    jQuery('.btn-next').removeClass('btn-disabled');
    updateAnchoredSelection(this.value);
  });

  jQuery('input[name="profi_mode"]').change(function () {
    updateProfiSelection(jQuery(this).prop('checked'));
  });

  if (jQuery('input[name="profi_mode"]').length) {
    updateProfiSelection(jQuery('input[name="profi_mode"]').prop('checked'));
  }

  jQuery('.btn-next').click(function () {
    var $input = jQuery('input[name=untergrund]:checked');

    if (!$input.length) {
      alert(tp_trans.trans('no_untergrund_selected_alert', 'Wählen Sie bitte einen Untergrund aus.'));
      return;
    }

    jQuery('.btn-next').removeClass('btn-disabled');
  });
};

com.parkside.deckform.init_abmessungen = function () {
  var imperialInputGroups = document.querySelectorAll('.imperial-input-group');
  var imperialHandlers = [...imperialInputGroups].map(group => new ImperialInputHandler(group));

  var $fields = jQuery('.size-parameter-group input.decimal, .size-parameter-group input.decimal-dot').keyup(isValid);

  imperialInputGroups.forEach(group => {
    group.querySelectorAll('select').forEach(select => select.addEventListener('change', () => isValid()));
    group.querySelectorAll('input').forEach(input => input.addEventListener('keyup', () => isValid()));
  });

  jQuery('.btn-next').click(function () {
    if (!isValid()) {
      alert(tp_trans.trans('fehler_eingabe_laenge', 'Bitte geben Sie die Längen Ihrer Terrasse ein.'));
      return;
    }

    com.parkside.loader.show(function () {
      document.forms['form_form_abmessungen'].submit();
    }, 'progress');
  });

  function isValid() {
    var valid = true;

    $.each($fields, function () {
      var value = parseFloat(this.value.replace(/,/g, '.'));

      valid = !isNaN(value) && value > 0;
      if (!valid) return false;
    });

    imperialHandlers.forEach(handler => {
      if (!handler.value) {
        valid = false;
        return false;
      }
    });

    jQuery('.btn-next')[!valid ? 'addClass' : 'removeClass']('btn-disabled');

    return valid;
  }

  isValid();
};

com.parkside.deckform.init_height_questions = function () {
  function onChange(event) {
    event.valid ? enableNextButton() : disableNextButton();
  }
  window.questionnaire = new Questionnaire({ onChange: onChange });
  window.questionnaire.init();
};
